/* eslint-disable react-hooks/exhaustive-deps */
import { tokens } from "../../../../theme";
import { Paper, Typography, useTheme } from "@mui/material";
import DataGridButton from "../../../../components/DataGridButton";
import { dataGridButtonTypography } from "../../../../styles/DataGridStyles";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { DB_PATCH_REPO_NAME } from "../../../../utils/constants";
import { githubUrl, simUrl } from "../../../../utils/urls";
import useIamModal from "../../../IamModal/UseIamModal";
import { buildDetailedPanelStyles } from "../../styles";
import StepBox from "./StepBox";
import {
  downloadFileFromUrl,
  toPascalCase,
} from "../../../../utils/helperFunctions";
import { Fragment } from "react/jsx-runtime";
import ResultBox from "../../../Automations/ResultBox";
import { complileResults } from "../../../Automations/utils";

const DetailPanelContent = ({
  row,
  showRetryDialog,
  retryPermissionList,
  setReportModalOpen,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { openIamModal, canViewIamModal, IamModal } = useIamModal(
    `/apps/tessell/software-images/db-software/builds/${row?.id}`,
    [],
    buildDetailedPanelStyles.otherDetailsButton
  );

  return (
    <Grid
      container
      sx={buildDetailedPanelStyles.mainGrid}
      justifyContent={"space-around"}
    >
      {IamModal}
      <Grid xs={6} lg={6}>
        <Paper elevation={4} sx={buildDetailedPanelStyles.paper}>
          <Typography variant="h4">Steps:</Typography>
          {row?.runData?.steps?.map((step) => (
            <StepBox
              step={step}
              showRetryDialog={showRetryDialog}
              id={row?.id}
              retryPermissionList={retryPermissionList}
            />
          ))}
        </Paper>
      </Grid>
      <Grid xs={6} lg={6}>
        <Paper elevation={4} sx={buildDetailedPanelStyles.paper}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant="h5" sx={{ mb: "10px" }}>
                Old Version Name: {row?.inputData?.oldPatchVersionName}
              </Typography>
            </Grid>
            {["installation", "validation"].map((scriptType, i) => (
              <Fragment key={i}>
                <Grid item xs={2}>
                  <Typography variant="h5" sx={{ textAlign: "center" }}>
                    {toPascalCase(scriptType)}:
                  </Typography>
                </Grid>
                <Grid item xs={2}>
                  <DataGridButton
                    sx={buildDetailedPanelStyles.logsButton}
                    onClick={() => {
                      const blob = new Blob(
                        [row?.inputData?.[`${scriptType}Script`]],
                        { type: "text/plain" }
                      );
                      const url = URL.createObjectURL(blob);

                      const a = document.createElement("a");
                      a.href = url;
                      a.download = `${scriptType}_script.sh`;
                      a.click();

                      URL.revokeObjectURL(url);
                    }}
                  >
                    <Typography sx={dataGridButtonTypography(colors, 500)}>
                      Script
                    </Typography>
                  </DataGridButton>
                </Grid>
                <Grid item xs={2}>
                  <DataGridButton
                    disabled={
                      !row?.runData?.steps?.some(
                        (step) =>
                          step?.stepName === `run-${scriptType}-script` &&
                          step?.status !== "RUNNING"
                      ) || !row?.runData?.steps?.length
                    }
                    sx={buildDetailedPanelStyles.logsButton}
                    onClick={() =>
                      downloadFileFromUrl(
                        `${simUrl}/apps/tessell/software-images/db-software/builds/${row?.id}/${scriptType}-logs`
                      )
                    }
                  >
                    <Typography sx={dataGridButtonTypography(colors, 500)}>
                      Logs
                    </Typography>
                  </DataGridButton>
                </Grid>
              </Fragment>
            ))}

            <Grid item xs={2}>
              {row?.runData?.steps?.filter((step) => {
                if (step.stepName === "commit-snapshot-yaml") {
                  return step.status === "COMPLETED";
                }
                return false;
              }).length > 0 ? (
                <DataGridButton
                  sx={buildDetailedPanelStyles.logsButton}
                  onClick={() =>
                    window.open(
                      `${githubUrl}/${DB_PATCH_REPO_NAME}/compare/${
                        row?.inputData?.releaseBranch
                      }...${
                        row?.jiraId
                      }_${row?.cloud.toLowerCase()}_convoy_db_software_patch_automation?expand=1`
                    )
                  }
                >
                  <Typography sx={dataGridButtonTypography(colors, 500)}>
                    Create PR
                  </Typography>
                </DataGridButton>
              ) : (
                <></>
              )}
            </Grid>
            <Grid item xs={2}>
              {canViewIamModal ? (
                <DataGridButton
                  sx={buildDetailedPanelStyles.logsButton}
                  onClick={() => openIamModal()}
                >
                  <Typography sx={dataGridButtonTypography(colors, 500)}>
                    IAM
                  </Typography>
                </DataGridButton>
              ) : (
                <></>
              )}
            </Grid>
            <Grid item xs={2} />

            {row?.runData?.steps?.filter((step) => {
              if (step.stepName === "trigger-qa") {
                return step.status === "COMPLETED";
              }
              return false;
            }).length > 0 ? (
              <>
                <Grid item xs={2}>
                  <Typography
                    variant="h5"
                    sx={buildDetailedPanelStyles.qaResultsTypography}
                  >
                    QA Results:
                  </Typography>
                </Grid>

                <Grid item xs={2}>
                  <ResultBox
                    compliedResults={complileResults(row?.runData?.qaResults)}
                    sx={buildDetailedPanelStyles.qaResultsBox}
                  />
                </Grid>
                <Grid item xs={2}>
                  <DataGridButton
                    sx={buildDetailedPanelStyles.logsButton}
                    onClick={() =>
                      setReportModalOpen(
                        `${simUrl}/apps/tessell/software-images/db-software/builds/${row?.id}/qa-automation-report`
                      )
                    }
                  >
                    <Typography sx={dataGridButtonTypography(colors, 500)}>
                      Report
                    </Typography>
                  </DataGridButton>
                </Grid>
              </>
            ) : (
              <></>
            )}
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default DetailPanelContent;
